import { Button, Drawer, Flex } from 'antd';
import { Cause, Issue } from '../../types';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import CauseCard from '../causeCard';
import IssueCard from '../issueCard';
import styled from 'styled-components';

export interface SelectCauseOrIssueDrawerProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (causes: string[]) => void;
  data: (Cause | Issue)[];
  title?: string;
  singleChoice?: boolean;
}

export const StyledListItem = styled(Flex)`
  &:hover {
    background-color: #fafafa;
  }
`;

const SelectCauseOrIssueDrawer = ({
  open,
  onClose,
  onConfirm,
  data,
  title,
  singleChoice,
}: SelectCauseOrIssueDrawerProps) => {
  const { t } = useTranslation();
  const [selectedIds, setSelectIds] = useState<string[]>([]);

  const handleCheckChange = (checked: boolean, id: string) => {
    if (singleChoice) {
      setSelectIds(checked ? [String(id)] : []);
      return;
    }
    const nextState = checked
      ? [...selectedIds, String(id)]
      : selectedIds.filter((c) => c !== String(id));
    setSelectIds(nextState);
  };

  useEffect(() => {
    if (!open) {
      setSelectIds([]);
    }
  }, [open]);

  return (
    <Drawer
      title={title || 'Link Cause(s)'}
      closable
      onClose={onClose}
      open={open}
      width={800}
      footer={
        <Flex justify="flex-end" gap={16}>
          <Button type="primary" ghost onClick={onClose}>
            {t('cancel')}
          </Button>
          <Button type="primary" onClick={() => onConfirm(selectedIds)}>
            {t('confirm')}
          </Button>
        </Flex>
      }
    >
      <Flex vertical gap={8}>
        {data.map((i) => (
          <StyledListItem key={'issueID' in i ? i.issueID : i.causeID}>
            {'issueID' in i ? (
              <IssueCard
                key={i.issueID}
                issue={i}
                checkable
                checked={selectedIds.includes(String(i.issueID))}
                onCheck={(checked) => handleCheckChange(checked, i.issueID)}
              />
            ) : (
              <CauseCard
                key={i.causeID}
                cause={i}
                checkable
                checked={selectedIds.includes(String(i.causeID))}
                onCheck={(checked) => handleCheckChange(checked, i.causeID)}
              />
            )}
          </StyledListItem>
        ))}
      </Flex>
    </Drawer>
  );
};

export default SelectCauseOrIssueDrawer;
